import { Phone } from "lucide-react";

export default function FloatingPhone() {
  return (
    <a href="tel:2368681195" className="floating-cta lg:hidden" data-testid="floating-cta">
      <Phone className="w-6 h-6" />
    </a>
  );
}
